import { Controller } from "@hotwired/stimulus"

// Reiter nach dem ARIA-Muster „Tabs“ (z. B. aktive/inaktive Benutzer). Das
// Markup zeigt alle Panels; erst der Controller blendet die übrigen aus. Ohne
// JS bleiben so alle Listen erreichbar. Pfeiltasten, Pos1 und Ende wechseln
// den Reiter. disconnect zeigt wieder alles, damit der Turbo-Cache keinen
// halben Zustand speichert.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const selected = this.tabTargets.findIndex((tab) => tab.getAttribute("aria-selected") === "true")
    this.show(Math.max(selected, 0))
  }

  disconnect() {
    this.panelTargets.forEach((panel) => { panel.hidden = false })
  }

  select(event) {
    this.show(this.tabTargets.indexOf(event.currentTarget))
  }

  navigate(event) {
    const current = this.tabTargets.indexOf(event.currentTarget)
    const last = this.tabTargets.length - 1
    const next = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: last }[event.key]
    if (next === undefined) return

    event.preventDefault()
    const index = (next + this.tabTargets.length) % this.tabTargets.length
    this.show(index)
    this.tabTargets[index].focus()
  }

  show(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.setAttribute("aria-selected", String(i === index))
      tab.tabIndex = i === index ? 0 : -1
    })
    this.panelTargets.forEach((panel, i) => { panel.hidden = i !== index })
  }
}
